import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useParams, useNavigate } from "react-router-dom";
import { getRequest } from "../utils/apicalls";
import { Pagination, Button } from "antd";
import "../styles/interndetail.css";
import { CloseOutlined } from "@ant-design/icons";
import mytLogo from "../image/myt logo.d51e67ca4d4eeea6450b.png";

const InternDetail = () => {
  const { id } = useParams();
  const [internInfo, setInternInfo] = useState({
    name: "",
    school: "",
    supervisor: "",
    hours_required: 0,
  });
  const [timesheets, setTimesheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const suffix = hours >= 12 ? "PM" : "AM";
    const standardHours = hours % 12 || 12;
    return `${standardHours}:${minutes.toString().padStart(2, "0")} ${suffix}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return date.toLocaleDateString(undefined, options);
  };

  const formatDate2 = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    const fetchApprovedTimesheets = async () => {
      try {
        const response = await getRequest(
          `timesheets/get_approved_interns_timesheets?screen=1&id=${id}&token=${token}`
        );

        const {
          name,
          school,
          hours_required,
          timesheets: ts,
        } = response.data || {};

        setInternInfo({
          name: name || "",
          school: school || "",
          supervisor: "OJT Supervisor",
          hours_required: parseFloat(hours_required) || 0,
        });

        setTimesheets(Array.isArray(ts) ? ts : []);
      } catch (error) {
        console.error("Timesheet fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedTimesheets();
  }, [id, token]);

  const goBack = () => {
    navigate("/interns");
  };

  // Calculate total hours
  const totalHours = timesheets.reduce((sum, ts) => {
    const hours = parseFloat(ts.total_hours);
    return sum + (isNaN(hours) ? 0 : hours);
  }, 0);

  const totalHoursRequired = parseFloat(internInfo.hours_required) || 0;
  const totalHoursLeft = Math.max(totalHoursRequired - totalHours, 0);

  // --- Print content ---
  // --- Print content ---
  const printContent = () => (
    <div className="print-content">
      <div className="print-header">
        <img src={mytLogo} alt="Logo" className="print-logo" />
        <h2>MYT SoftDev Solutions, Inc.</h2>
        <p>301 The Greenery, Pope John Paul II Ave, Cebu City, 6000 Cebu</p>
        <h3>DAILY TIME RECORD</h3>
      </div>

      <table className="print-info-table">
        <tbody>
          <tr>
            <td>
              <strong>Name of Student:</strong> {internInfo.name}
            </td>
            <td>
              <strong>Organization:</strong> {internInfo.school}
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <strong>Designation:</strong>
              <div>Intern</div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* PRINT TABLE */}
      <table className="print-record-table">
        <thead>
          <tr>
            <th rowSpan="2">Date</th>
            <th rowSpan="2">
              Set Up
              <br />
              (F2F/Remote)
            </th>
            <th colSpan="2">Morning</th>
            <th colSpan="2">Afternoon</th>
            <th rowSpan="2"># of Hours</th>
            <th rowSpan="2">Approved by</th>
          </tr>
          <tr>
            <th>Start</th>
            <th>End</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>

        <tbody>
          {timesheets.length > 0 ? (
            timesheets.map((ts, i) => (
              <tr key={i}>
                <td>{formatDate2(ts.date)}</td>
                <td>
                  {ts.am_modality === ts.pm_modality
                    ? ts.am_modality
                    : `${ts.am_modality} / ${ts.pm_modality}`}
                </td>
                <td>{convertTo12HourFormat(ts.time_in_am)}</td>
                <td>{convertTo12HourFormat(ts.time_out_am)}</td>
                <td>{convertTo12HourFormat(ts.time_in_pm)}</td>
                <td>{convertTo12HourFormat(ts.time_out_pm)}</td>
                <td>{ts.total_hours || ""}</td>
                <td>
                  {ts.approved_by && ts.approved_on
                    ? `${ts.approved_by} (${formatDate(ts.approved_on)})`
                    : ts.approved_by || ""}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No Approved Records
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* PRINT TOTALS */}
      <div className="print-total-hours">
        <div>
          <strong>Total Hours Rendered:</strong> {totalHours.toFixed(2)}
        </div>
      </div>

      {/* PRINT SUPERVISOR */}
      <div className="print-supervisor-section">
        <div className="print-supervisor-line-wrapper">
          <div className="print-supervisor-line" />
          <div className="print-supervisor-name">
            <strong>{internInfo.supervisor || "OJT Supervisor"}</strong>
          </div>
        </div>
      </div>
    </div>
  );
  const handlePrint = () => {
    const content = ReactDOMServer.renderToStaticMarkup(printContent());
    const printWindow = window.open("", "_blank", "width=900,height=700");

    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Print - Intern Daily Time Record</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 20px;
                color: #000;
              }
  
              .print-content {
                padding: 20px;
                color: #000;
              }
  
              .print-header {
                text-align: center;
                margin-bottom: 20px;
              }
  
              .print-header h2,
              .print-header h3,
              .print-header p {
                margin: 5px 0;
              }
  
              .print-logo {
                width: 100px;
                margin-bottom: 10px;
              }
  
              .print-info-table,
              .print-record-table {
                width: 100%;
                border-collapse: collapse;
              }
  
              .print-info-table {
                margin-bottom: 20px;
                border: 1px solid #000;
              }
  
              .print-info-table td,
              .print-record-table th,
              .print-record-table td {
                border: 1px solid #000;
                padding: 6px;
              }
  
              .print-info-table td {
                text-align: left;
                vertical-align: top;
              }
  
              .print-record-table th,
              .print-record-table td {
                text-align: center;
                vertical-align: middle;
                font-size: 12px;
              }
  
              .print-total-hours {
                margin-top: 20px;
              }
  
              .print-total-hours div {
                margin-bottom: 6px;
              }
  
              .print-supervisor-section {
                margin-top: 50px;
                display: flex;
                justify-content: flex-end;
              }
  
              .print-supervisor-line-wrapper {
                width: 250px;
                text-align: center;
              }
  
              .print-supervisor-line {
                border-top: 1px solid #000;
                margin-bottom: 8px;
                width: 100%;
              }
  
              .print-supervisor-name {
                text-align: center;
              }
  
              @media print {
                body {
                  margin: 20px;
                }
              }
            </style>
          </head>
          <body>
            ${content}
            <script>
              window.onload = function() {
                window.print();
                window.onafterprint = function() { window.close(); };
              };
            </script>
          </body>
        </html>
      `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.close();
      }, 1500);
    }
  };

  return (
    <div className="dtr-container">
      <div className="dtr-paper">
        <div className="close-icon-container">
          <CloseOutlined
            onClick={goBack}
            style={{ fontSize: "20px", cursor: "pointer" }}
          />
        </div>
        {/* Print Button */}
        <div style={{ textAlign: "right" }}>
          <Button type="primary" onClick={handlePrint}>
            Print
          </Button>
        </div>
        <div className="dtr-header">
          <img src={mytLogo} alt="Logo" className="dtr-logo" />
          <div className="dtr-header-text">
            <h2 className="dtr-company-name">MYT SoftDev Solutions, Inc.</h2>
            <p className="dtr-company-address">
              301 The Greenery, Pope John Paul II Ave, Cebu City, 6000 Cebu
            </p>
          </div>
        </div>
        <h3 className="dtr-title">DAILY TIME RECORD</h3>
        <div className="dtr-info-table">
          <div className="dtr-info-cell">
            <strong>Name of Student:</strong>
            <div className="dtr-info-value">{internInfo.name}</div>
          </div>
          <div className="dtr-info-cell">
            <strong>Organization:</strong>
            <div className="dtr-info-value">{internInfo.school}</div>
          </div>
          <div className="dtr-info-cell">
            <strong>Designation:</strong>
            <div className="dtr-info-value">Intern</div>
          </div>
        </div>

        <div className="dtr-table-wrapper">
          <table className="dtr-record-table">
            <thead>
              <tr>
                <th className="dtr-date-col" rowSpan="2">
                  Date
                </th>
                <th rowSpan="2">
                  Set Up
                  <br />
                  (F2F/Remote)
                </th>
                <th colSpan="2">Morning</th>
                <th colSpan="2">Afternoon</th>
                <th rowSpan="2"># of Hours</th>
                <th rowSpan="2">Approved by</th>
              </tr>
              <tr>
                <th>Start</th>
                <th>End</th>
                <th>Start</th>
                <th>End</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : timesheets.length > 0 ? (
                timesheets.map((ts, index) => (
                  <tr key={index}>
                    <td>{formatDate2(ts.date)}</td>
                    <td>
                      {ts.am_modality === ts.pm_modality
                        ? ts.am_modality
                        : `${ts.am_modality} / ${ts.pm_modality}`}
                    </td>

                    <td>{convertTo12HourFormat(ts.time_in_am)}</td>
                    <td>{convertTo12HourFormat(ts.time_out_am)}</td>
                    <td>{convertTo12HourFormat(ts.time_in_pm)}</td>
                    <td>{convertTo12HourFormat(ts.time_out_pm)}</td>
                    <td>{ts.total_hours || ""}</td>
                    <td>
                      {ts.approved_by && ts.approved_on
                        ? `${ts.approved_by} (${formatDate(ts.approved_on)})`
                        : ts.approved_by || ""}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No Approved Records
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ✅ Total Hours Section */}
        <div className="dtr-total-hours">
          <div>
            <strong>Total Hours Required:</strong>{" "}
            {totalHoursRequired.toFixed(2)}
          </div>
          <div>
            <strong>Total Hours Rendered:</strong> {totalHours.toFixed(2)}
          </div>
          <div>
            <strong>Total Hours Left:</strong> {totalHoursLeft.toFixed(2)}
          </div>
        </div>
        <div className="ojt-supervisor-section">
          <div className="ojt-supervisor-line-wrapper">
            <div className="ojt-line" />
            <div className="ojt-supervisor">
              <strong>{internInfo.supervisor || "OJT Supervisor"}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternDetail;
